const blobUrlFormatHelper = (relativeUrl: string): string => {
  if (!relativeUrl) return "";

  if (/^(data:|blob:|https?:\/\/)/i.test(relativeUrl)) {
    return relativeUrl;
  }

  //else create an actual server request url
  return "/api/Asset/" + relativeUrl;
};

export default blobUrlFormatHelper;
